import { createAction } from 'redux-act';

export const rateStay = createAction('stayRating/CREATE_STAY_RATING');
